import React from 'react';
import toAvg from "../Utils/typesOfAvg.jpg";
import macd1 from '../Utils/macd1.png';
import advLim from "../Utils/advLim.png";
import movAvg from '../Utils/artices.png';

const MovingAvg = () => {
  return (
    <div style={{ backgroundColor: "#E5E7EB" }}>
        <div class="container"> 
    <div class="article-header text-center"> 
      <h1 class="article-title">Why moving averages are so popular in trading.</h1> 
      <p class="article-meta">Moving averages | July 30, 2023</p> </div> 
      <div>
        <img src={movAvg} alt="img" width="100%" height="550vp"/>

      </div>
      <div class="article-content"> 
        <h2 class="article-section-title">Introduction</h2> 
        <p>
          Moving averages (MAs) are widely used in trading for various purposes, helping traders make more informed decisions based on trends, price action, and market behavior. Below are some common ways moving averages are used in trading</p>
        <br />
        <img  src={toAvg} alt="types of avg img" width="80%"/>
        <img  src={macd1} alt="types of avg img" width="80%"/> 
        <img  src={advLim} alt="types of avg img" width="80%"/> 

    </div>
       </div>
      
    </div>
  )
}

export default MovingAvg;
